import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { addToCarts, setCart, setUser, fetchUserData } from "../../redux/actions";

const AddingProductToCartModal = ({ onClose, locationList = [], product = {}, productVariation = {}, quantity = {}, region }) => {

    const dispatch = useDispatch();
    const successToastId = "addToCartSuccess";

    const addToCartToThisLocation = async (locationId) => {
        const body = document.body;
        const scrollY = window.scrollY;
    
        // Prevent scrolling during modal close
        body.style.position = "fixed";
        body.style.top = `-${scrollY}px`;
        body.style.width = "100%";

        try {            
            const createCart = await addToCarts(productVariation, quantity, locationId, region, dispatch);

            if(createCart) {
                const user = await fetchUserData();
                if(user) {
                    dispatch(setUser(user));
                    dispatch(setCart(createCart));
                     
                    setTimeout(() => {
                        if (!toast.isActive(successToastId)) {
                            toast.success(
                                <div style={{
                                    width: "380px",
                                    height: "120px"
                                }}>
                                    <p className="mt-10 mb-20">Product added to cart</p>
                                    <div className="d-flex justify-content-between align-items-center gap-3">
                                        <button
                                            className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center me-2"
                                            onClick={() => toast.dismiss(successToastId)}
                                        >
                                            Shop More
                                        </button>
            
                                        <button
                                            className="btn btn-sm p-10 bg-main-product-50 hover-bg-main-product-50 flex-fill text-center ms-2"
                                            onClick={() => (window.location.href = "/cart/one-time")}
                                        >
                                            View Cart
                                        </button>
                                    </div>
                                </div>, 
                                { toastId: successToastId }
                            );
                        }
                    }, 500);                
                }          
            }
        } catch (error) {
            console.log(error);
        }   

        onClose();   

        // Restore scroll position after modal closes
        setTimeout(() => {
            body.style.position = "";
            body.style.top = "";
            window.scrollTo(0, scrollY);
        }, 0);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content ">
                <button className="close-btn" onClick={onClose}>
                    &times;
                </button>
                <h3 className="text-blue">Add To Cart</h3>
                <span className="p-5">
                    Please choose the location to which you wish to order this product.
                </span>

                <div className="flex w-full flex-col gap-y-4 overflow-y-auto">
                    {locationList.map((location, index) => (
                        <Fragment key={index}>
                            <div className="mb-10 h-px w-full bg-medium-grey mt-10" />

                            <Link
                                className="modal-link p-10"
                                onClick={() => addToCartToThisLocation(location?.id)}
                            >
                                {location.name+ ',' + location.delivery_address.street + ',' + location.delivery_address.city}
                            </Link>
                        </Fragment>
                    ))}
                </div>
                <Link
                    to="/self-service/mycompany/actions"
                        className="d-flex align-items-center gap-2 text-decoration-none text-lg p-5 mt-20"
                >
                    <span className="w-20 h-20 bg-main-50 text-xs d-flex justify-content-center align-items-center rounded-circle">
                        <i className="ph ph-plus"></i>
                    </span>
                    &nbsp;&nbsp;Add another delivery location
                </Link>
            </div>
        </div>
    );
};

export default AddingProductToCartModal;
